/**
 * The invite secret is removed from the URL on load. Keeping it in sessionStorage (this tab
 * only, keyed by invite) lets a reload or a sign-out redirect reopen the same invite. It never
 * goes back into the URL, history or monitoring.
 */
const keyFor = (organizationId: string, userId: string) =>
  `inviteToken:${organizationId}/${userId}`;

export const rememberInviteToken = (organizationId: string, userId: string, token: string) => {
  try {
    sessionStorage.setItem(keyFor(organizationId, userId), token);
  } catch {
    // Storage blocked: the invitee can open the email link again.
  }
};

export const recallInviteToken = (organizationId: string, userId: string): string | undefined => {
  try {
    return sessionStorage.getItem(keyFor(organizationId, userId)) || undefined;
  } catch {
    return undefined;
  }
};

export const forgetInviteToken = (organizationId: string, userId: string) => {
  try {
    sessionStorage.removeItem(keyFor(organizationId, userId));
  } catch {
    // Nothing stored.
  }
};
